// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BaseError_title__PFdeM{font-size:24pt}.BaseError_content__gQTxg{max-width:400px}", "",{"version":3,"sources":["webpack://./src/common/Errors/BaseError.scss"],"names":[],"mappings":"AAAuC,wBAErC,cAAA,CAGF,0BAEE,eAAA","sourcesContent":["@import \"assets/styles/variables.scss\";.title {\n  composes: py-5 font-weight-bold from global;\n  font-size: 24pt;\n}\n\n.content {\n  composes: py-5 text-center from global;\n  max-width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "BaseError_title__PFdeM py-5 font-weight-bold",
	"content": "BaseError_content__gQTxg py-5 text-center"
};
export default ___CSS_LOADER_EXPORT___;
